'use client';

import React from 'react';
import { AuthProvider } from '@/contexts/AuthContext';
import { MultiplierProvider } from '@/contexts/MultiplierContext';
import { AchievementNotificationProvider } from '@/contexts/AchievementNotificationContext';
import { AchievementProvider } from '@/contexts/AchievementContext';
// import { Toaster } from 'react-hot-toast';

interface ClientWrapperProps {
  children: React.ReactNode;
}

export default function ClientWrapper({ children }: ClientWrapperProps) {
  return (
    <AuthProvider>
      <AchievementProvider>
        <MultiplierProvider>
          <AchievementNotificationProvider>
            {children}
          </AchievementNotificationProvider>
        </MultiplierProvider>
      </AchievementProvider>
    </AuthProvider>
  );
}
